module.exports = __webpack_public_path__ + "images/cc.d906fe5c1274c56c5571.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/cc.png
// module id = jJaS
// module chunks = 0